import React, { useState, useEffect } from 'react';
import {
  Table,
  Select,
  Button,
  Space,
  InputNumber,
  message,
} from 'antd';
import { apiRequest } from '../../../service/apiRequest';
import { showSuccess, showError } from '../../../components/errorHandler';


const { Option } = Select;

interface Tailor {
  ledger_id: number;
  ledger_name?: string;
}

interface Product {
  product_id: number;
  product_name: string;
}

interface TailorPrice {
  tp_product_id: number;
  tp_price: number;
}

const TailorPriceManager: React.FC = () => {
  const [tailors, setTailors] = useState<Tailor[]>([]);
  const [selectedTailorId, setSelectedTailorId] = useState<number | undefined>(undefined);
  const [products, setProducts] = useState<Product[]>([]);
  const [tailorPrices, setTailorPrices] = useState<TailorPrice[]>([]);
  const [updatedPrices, setUpdatedPrices] = useState<Record<number, number>>({});
  const [loading, setLoading] = useState(false);
  

  // Fetch tailors on mount
  useEffect(() => {
    async function fetchTailors() {
      try {
        const data = await apiRequest({ method: 'get', url: '/ledger-data' });
        console.log("data",data)
        setTailors(
          data.ledgers.map((t: any) => ({
            ledger_id: t.ledger_id,
            ledger_name: t.ledger_first_name + ' ' + t.ledger_last_name,
          }))
        );
      } catch {
        message.error('Failed to load tailors');
      }
    }
    fetchTailors();
  }, []);

  // Fetch products and prices when tailor is selected
  useEffect(() => {
    if (!selectedTailorId) {
      setProducts([]);
      setTailorPrices([]);
      setUpdatedPrices({});
      return;
    }

    async function fetchProductsAndPrices() {
      setLoading(true);
      try {
        const productsData = await apiRequest<Product[]>({ method: 'get', url: '/all-products-data' });
        const pricesData = await apiRequest<TailorPrice[]>({ method: 'get', url: `/tailor-price?ledger_id=${selectedTailorId}` });

        setProducts(productsData);
        setTailorPrices(pricesData);
        console.log(productsData)
        // Initialize updatedPrices map
        const priceMap: Record<number, number> = {};
        productsData.forEach((p) => {
          const priceEntry = pricesData.find((tp) => tp.tp_product_id === p.product_id);
          priceMap[p.product_id] = priceEntry ? priceEntry.tp_price : 0;
        });

        setUpdatedPrices(priceMap);
      } catch {
        message.error('Failed to load products or prices');
      }
      setLoading(false);
    }
    fetchProductsAndPrices();
  }, [selectedTailorId]);

  // Handle price input change
  const handlePriceChange = (productId: number, value: number | null) => {
    setUpdatedPrices((prev) => ({ ...prev, [productId]: value ?? 0 }));
  };

  // Update prices API call
  const handleUpdatePrices = async () => {
    if (!selectedTailorId) {
      message.error('Please select a tailor first');
      return;
    }
    // setLoading(true);
    try {
      const payload = Object.entries(updatedPrices).map(([productId, price]) => ({
        tp_ledger_id: selectedTailorId,
        tp_product_id: Number(productId),
        tp_price: price,
      }));

      await apiRequest({
        method: 'post',
        url: '/tailor-price',
        data: payload,
      });
     showSuccess('Prices updated successfully');
       
    } catch {
      showError('Failed to update prices');
    }
    // setLoading(false);
  };

  const columns = [
    {
      title: 'Product product_name',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Product Code',
      dataIndex: 'product_code',
      key: 'product_code',
    },
    {
      title: 'Price',
      dataIndex: 'product_id',
      key: 'price',
      // render: (productId: number) => (
      //   <InputNumber
      //     min={0}
      //     value={updatedPrices[productId]}
      //     onChange={(value) => handlePriceChange(productId, value)}
      //     disabled={loading}
      //   />
       render: (_: any, record: Product) => (
        <InputNumber
          min={0}
          max={10000}
          maxLength={5}
          value={updatedPrices[record.product_id]}
          onChange={(value) => handlePriceChange(record.product_id, value)}
          disabled={loading}
          style={{ width: '50%' }} 
        />
            ),
          },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Select
          placeholder="Select Tailor"
          style={{ width: 240 }}
          onChange={setSelectedTailorId}
          allowClear
          value={selectedTailorId}
          loading={loading}
          showSearch
          optionFilterProp="children"
        >
          {tailors.map((t) => (
            <Option key={t.ledger_id} value={t.ledger_id}>
              {t.ledger_name}
            </Option>
          ))}
        </Select>
        <Button type="primary" onClick={handleUpdatePrices}>
          Update Prices
        </Button>
      </Space>

      <Table
        columns={columns}
        dataSource={products}
        rowKey="product_id"
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default TailorPriceManager;
